import CardsList from "@/components/cardsList";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComp = () => {
  return <CardsList columns={{ base: 1, sm: 3 }} list={FEATURES_CONSTANTS} />;
};

export default FeaturesComp;
